module.exports = __webpack_public_path__ + "img/lange-vingers-dippen-in-chocolademelk.82358917.jpeg";